import React from "react";
import { Row, Col } from "react-bootstrap";
import T from "prop-types";
import { dollars } from "LIB/formatters/currency";
import { percent } from "LIB/formatters/number";
import { DataTable } from "MODULES/shared/components";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { shortDate } from "LIB/formatters/date";

function renderRow(r) {
  return (
    <tr key={r.buyer}>
      <td>{shortDate(r.inception_date)}</td>
      <td>{r.consignment_company_name}</td>
      <td className="text-right">{r.consignment_reference}</td>
      <td className="text-right">
        {percent(Number(r.consignor_percentage), 100)}
      </td>
      <td className="text-right">{r.manager}</td>
      <td className="text-right">{dollars(r.total_sold)}</td>
      <td className="text-right">{dollars(r.total_paid_to_consignor)}</td>
      <td className="text-right">{dollars(r.profit)}</td>
      <td className="text-right">{r.cancelled_consignments}</td>
      <td className="text-right">{r.total_line_items_remaining}</td>
      <td className="text-right">{r.total_qty_remaining}</td>
      <td className="text-right">
        {percent(r.total_realized, r.total_purchases)}
      </td>
    </tr>
  );
}

function Table({ currentUser, isLoading, pageActions, results }) {
  return (
    <React.Fragment>
      <Row>
        <Col md={12}>
          <DataTable loading={isLoading} refresh={pageActions.expire}>
            <DataTable.Head>
              <th>Inception Date</th>
              <th>Consignor</th>
              <th className="text-right">Consignment Ref #</th>
              <th className="text-right">Consignor Perc (%)</th>
              <th className="text-right">Manager</th>
              <th className="text-right">Total Sold</th>
              <th className="text-right">Total Paid To Consignor</th>
              <th className="text-right">Total Earned</th>
              <th className="text-right">Total Canceled</th>
              <th className="text-right">Total Lines Items Remaining</th>
              <th className="text-right">Total Quantities Remaining</th>
            </DataTable.Head>
            <DataTable.Body>
              {results.map(r => renderRow(r, currentUser))}
            </DataTable.Body>
          </DataTable>
        </Col>
      </Row>
    </React.Fragment>
  );
}

Table.propTypes = {
  currentUser: T.shape({})
};

export default withCurrentUser(Table);



// WEBPACK FOOTER //
// ./app/modules/Admin/ConsignmentReportCard/Table.jsx